import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
import { down } from "../../../styles/breakpoints";
import { cardGrid } from "../../../styles/pageShell";

const useStyles = createUseStyles((_) => ({
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
  },

  /* KPI row. 220px keeps a currency figure like "1 234 567 EUR" on one line
     at the default h2 size; below that the number wraps under its own label. */
  kpiGrid: cardGrid(220),

  kpiCard: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    borderRadius: "15px",
    padding: "24px",
    minWidth: 0,
    backgroundColor: colors.WHITE,
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.09)",
    [down.sm]: {
      padding: "20px",
      gap: "14px",
    },
  },

  kpiHead: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    minWidth: 0,
  },

  kpiBody: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    minWidth: 0,
  },

  /* Long currency strings must break rather than widen the grid column and
     force the whole row to scroll horizontally. */
  kpiValue: {
    minWidth: 0,
    overflowWrap: "anywhere",
  },

  kpiFooter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "6px",
    flexWrap: "wrap",
    minWidth: 0,
  },

  trendUp: {
    color: colors.success,
    fontSize: "13px",
    fontWeight: 600,
  },

  trendDown: {
    color: colors.red,
    fontSize: "13px",
    fontWeight: 600,
  },

  trendFlat: {
    color: colors.greydark,
    fontSize: "13px",
    fontWeight: 600,
  },

  /* Chart card + plan breakdown sit side by side on desktop, stack on
     tablet. 320px is the narrowest a 12-point line chart stays legible. */
  splitRow: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 2fr) minmax(0, 1fr)",
    gap: "12px",
    [down.md]: {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },

  panel: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    borderRadius: "15px",
    padding: "24px",
    minWidth: 0,
    backgroundColor: colors.WHITE,
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.09)",
    [down.sm]: {
      padding: "20px",
    },
  },

  chartWrap: {
    width: "100%",
    height: "260px",
    minWidth: 0,
    "& svg": {
      maxWidth: "100%",
    },
  },

  planList: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    minWidth: 0,
  },

  planRow: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minWidth: 0,
  },

  planRowHead: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: "10px",
    minWidth: 0,
  },

  planName: {
    fontSize: "14px",
    fontWeight: 600,
    color: colors.BLACK,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },

  planValue: {
    fontSize: "14px",
    fontWeight: 700,
    color: colors.BLACK,
    whiteSpace: "nowrap",
  },

  planMeta: {
    fontSize: "12px",
    color: colors.greydark,
  },

  /* Share-of-MRR bar. Purely comparative, so it carries no axis. */
  planBarTrack: {
    width: "100%",
    height: "6px",
    borderRadius: "3px",
    backgroundColor: colors.default,
    overflow: "hidden",
  },

  planBarFill: {
    height: "100%",
    borderRadius: "3px",
    backgroundColor: colors.primary,
    transition: "width 400ms ease",
  },

  emptyState: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "24px 0",
    textAlign: "center",
    color: colors.greydark,
    fontSize: "13px",
  },
}));

export default useStyles;
